import React, {Component} from 'react';
import {Link} from "react-router-dom";

class ListHostingCancelComponent extends Component {

    loadStatus = () => {
        if ( this.props.service.status_hosting === 'on' ) {
            return (
                <span className="text-success">
                    Đang bật
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'off' ) {
            return (
                <span className="text-danger">
                    Đã tắt
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'admin_off' ) {
            return (
                <span className="text-danger">
                    Admin tắt
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'progressing' || this.props.service.status_hosting === 'waiting' ) {
            return (
                <span className="text-info">
                    Đang tạo
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'expire' ) {
            return (
                <span className="text-danger">
                    Hết hạn
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'cancel' ) {
            return (
                <span className="text-danger">
                    Đã hủy
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'delete' ) {
            return (
                <span className="text-danger">
                    Đã xóa
                </span>
            )
        }
        else if ( this.props.service.status_hosting === 'change_user' ) {
            return (
                <span className="text-danger">
                    Đã chuyển
                </span>
            )
        }
        else {
            return (
                <span className="text-danger">
                    Chưa tạo
                </span>
            )
        }
    }

    checkedService = () => {
        // console.log("da den")
        this.props.checkedService( this.props.actionKey );
    }

    render() {
        return (
            <>
                {
                    this.props.service.error === 0 ? (
                        <tr>
                            <td>
                                <Link to={'/dich-vu-hosting/' + this.props.service.domain + '/chi-tiet-dich-vu-hosting.html'}>{this.props.service.domain}</Link>
                            </td>
                            <td>
                                { this.props.service.product_name }
                            </td>
                            <td>
                                { this.props.service.text_create_date }
                            </td>
                            <td>
                                {
                                    this.props.service.isExpire || this.props.service.expired ? (
                                        <>
                                            <span className="text-danger">{ this.props.service.text_next_due_date } </span>
                                            -
                                            <span className="text-danger"> { this.props.service.text_day }</span>
                                        </>
                                    ) : (
                                        <>
                                            { this.props.service.text_next_due_date } - { this.props.service.text_day }
                                        </>
                                    )
                                }
                            </td>
                            <td>
                                { this.props.service.text_total_time }
                            </td>
                            <td>
                                { this.props.service.text_billing_cycle }
                            </td>
                            <td>
                                { this.props.service.text_amount }
                            </td>
                            <td>
                                { this.loadStatus() }
                            </td>
                        </tr>
                    ) : (
                        <tr>
                            <td colSpan={15} className="text-danger text-center">
                                { this.props.service.message }
                            </td>
                        </tr>
                    )
                }
            </>
        );
    }
}

export default ListHostingCancelComponent;